<template>
  <section class="mb7" :name="opts.hash" :id="opts.hash">
    <div :class="opts.rowClasses">
      <div :class="row.classes" v-for="row in opts.rows">
        <img v-for="image in row.images"
          :src="image[0].image"
          :width="image[1]"
          :height="image[2]"
          v-on:click="clickHandler(image)"
          class="image image-hover grow"
          >
        </img>
      </div>
    </div>
    <div class="w-100 pv2">
      <div class="mw5 mw6-ns relative" style="left: 10vw;">
        <h1 class="fw5 brown poppins-medium"> {{opts.title}} </h1>
        <p class="lh-copy brown f5 f4-ns poppins-regular"> {{opts.description}} </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Footer',
  props: ['opts'],
  data () {
    return {
      clickedImage: null
    }
  },
  methods: {
    clickHandler: function (image) {
      this.$emit('showModal', image)
    }
  }
}
</script>

<style scoped>
  .image {
    margin-right: 1em;
    margin-bottom: 1em;
  }
</style>
